import axios from 'axios';

const API = axios.create({
    baseURL: 'https://api.nimmihardware.com/'
});


// API.interceptors.request.use(function (config) {
//     const token = sessionStorage.getItem('token');
//     config.headers['Content-Type'] = 'application/json';
//     config.headers.Authorization = token ? `Bearer ${token}` : '';
//     return config;
// });

API.interceptors.response.use(
    (response) => {
        if (response.data) {
            return response.data;
        }
        return response;
    }, (error) => {
        // if (error?.response?.status === 401) {
        //     window.location.href = '/';
        //     toast.error("Session expired");
        // }
        // return error.response && error.response.data ? error.response.data : {};
        return error;
    }
);


export default API;